export default __webpack_public_path__ + "static/media/nodeJS.b235615d.png";